// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  seasonId: __t.u64().primaryKey().name("season_id"),
  seasonIndex: __t.u32().name("season_index"),
  startedAt: __t.timestamp().name("started_at"),
  endsAt: __t.timestamp().name("ends_at"),
  subsidyBps: __t.i64().name("subsidy_bps"),
  active: __t.bool(),
});
